const ErorrView = ({ setView }) => {

  return (
    <div>
      Error
      {/* TODO: Error Page */}
      <button onClick={() => setView("validateData")}>Regresar</button>
    </div>
  )
};

export default ErorrView